import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

/**
 * データ整合性診断API（店舗ユーザー向け）クライアント。
 *
 * バックエンドは `GET /api/v2/eod_closing/data_integrity_diagnostics`。
 * axios の baseURL に `/api` が含まれるため、ここでは `/v2/...` で指定する。
 *
 * - 通常レスポンス: `summary`（total_findings, by_category）＋
 *   営業日ごとの `rows`（business_date, total, by_category, findings[]）
 * - `summaryOnly=true` のとき: `{ has_unsaved: boolean, total_findings: integer }` のみ
 *
 * finding の主なフィールド:
 *   category / severity / context_type / context_id / context_name /
 *   aggregation_id / aggregation_name / business_rule_name / recommended_action
 */
export default {
  /**
   * 期間内の診断結果を取得する。
   * @param {string} from - 開始営業日 (YYYY-MM-DD)
   * @param {string} to - 終了営業日 (YYYY-MM-DD)。from との差は最大93日。
   */
  getDiagnostics(from, to) {
    return axiosIns.get('/v2/eod_closing/data_integrity_diagnostics', {
      params: snakecaseKeys({ from, to }),
    })
  },

  /**
   * サイドバーバッジ用の軽量レスポンスを取得する。
   * `{ has_unsaved: boolean, total_findings: integer }` のみが返る。
   * @param {string} from - 開始営業日 (YYYY-MM-DD)
   * @param {string} to - 終了営業日 (YYYY-MM-DD)
   */
  getDiagnosticsSummary(from, to) {
    return axiosIns.get('/v2/eod_closing/data_integrity_diagnostics', {
      params: snakecaseKeys({ from, to, summaryOnly: true }),
    })
  },
}
